import {
  absoluteValue,
  createBigDecimal,
  minus,
  plus,
} from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'
import { createAssetKey } from './createAssetKey'

export const mergeActionTransfers = (
  transfers: readonly Transfer[],
): readonly Transfer[] => {
  const assetTransfers = new Map<string, Transfer>()

  for (const transfer of transfers) {
    const key = createAssetKey(transfer.asset)
    const targetTransfer = assetTransfers.get(key) ?? {
      direction: 'none',
      asset: transfer.asset,
      amount: createBigDecimal(0n),
      price: transfer.price,
    }
    switch (transfer.direction) {
      case 'in': {
        targetTransfer.amount = plus(targetTransfer.amount, transfer.amount)
        break
      }
      case 'out': {
        targetTransfer.amount = minus(targetTransfer.amount, transfer.amount)
        break
      }
      case 'none': {
        break
      }
      default: {
        throw new Error(
          `Unknown transfer direction: ${transfer.direction satisfies never}`,
        )
      }
    }
    assetTransfers.set(key, targetTransfer)
  }

  const mergedTransfers: Transfer[] = []
  for (const transfer of assetTransfers.values()) {
    if (transfer.amount.value > 0n) {
      transfer.direction = 'in'
      mergedTransfers.push(transfer)
    } else if (transfer.amount.value < 0n) {
      transfer.direction = 'out'
      transfer.amount = absoluteValue(transfer.amount)
      mergedTransfers.push(transfer)
    }
  }

  return mergedTransfers
}
